<template>
    <q-dialog
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <q-card bordered square flat style="min-width: 50vw;">
            <q-toolbar>
                <q-toolbar-title>
                    <q-icon name="mdi-swap-horizontal" /> Swap
                </q-toolbar-title>

                <q-btn
                    dense
                    round
                    flat
                    icon="mdi-close"
                    v-close-popup
                />
            </q-toolbar>
            
            <q-separator />

            <q-card-section>
                <q-item-label>
                    Swap <span class="text-deep-orange-12">customer</span> and/or <span class="text-blue-12">work type</span> for this work item.
                </q-item-label>
                <q-item-label style="opacity: 0.7;" class="q-pt-sm">
                    When the customer is swapped, the work type will be reset to the default work type for the customer. Sub-Customers without work types will assume the work types of the main customer.
                </q-item-label>
            </q-card-section>
            
            <q-separator />

            <q-card-section class="q-pa-none">
                <q-list separator>
                    <template
                        v-for="(_model) in [ 'customer', 'subCustomer' ]"
                    >
                        <!-- 
                            Note:
                                This is a hack to not be so verbose with customer and subCustomer.
                                Unless we want to have 2 elements with the same info... `_model` 
                                goes unused.
                         -->
                        <CustomerWorkTypes
                            :content-inset-level="0.125"
                            :group="group ? 'swap-group' : undefined"

                            v-for="(subCustomer) in (_model == 'subCustomer' ? customer.sub_customers : 1)"
                            
                            :customer="customer"
                            :sub-customer="_model == 'subCustomer' ? subCustomer : null"

                            v-model:work-type-id="selectedWorkType"
                            v-model:sub-customer-id="selectedSubCustomer"

                            @customer-change="$event => selected.subCustomer = $event"
                            @work-type-change="$event => selected.workType = $event"
                        />
                    </template>
                </q-list>

                <q-inner-loading
                    :showing="loading"
                    label="Loading Customer Information..."
                />
            </q-card-section>

            <q-separator />

            <q-card-actions align="right">
                <q-btn
                    :disable="loading || (selectedSubCustomer == subCustomerId && selectedWorkType == workTypeId)"
                    color="positive"
                    label="Submit"
                    @click="submit()"
                />
                <q-btn
                    flat
                    :disable="(selectedSubCustomer == subCustomerId && selectedWorkType == workTypeId)"
                    color="primary"
                    label="Reset"
                    @click="reset()"
                />
                <q-btn
                    flat
                    color="negative"
                    label="Cancel"
                    @click="$emit('update:modelValue', false)"
                />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import CustomerWorkTypes from './SwapDialog/CustomerWorkTypes.vue';

export default {
    name: 'SwapDialog',
    emits: [
        'customerChange',
        'workTypeChange',
        'update:modelValue',
        'update:workTypeId',
        'update:subCustomerId',
    ],
    components: {
        CustomerWorkTypes,
    },
    props: {
        customer: {
            type: Object,
            required: true
        },
        modelValue: {
            type: Boolean,
            default: false
        },
        workTypeId: {
            type: Number,
            default: null
        },
        subCustomerId: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            group: true,
            loading: false,
            selected: {
                workType: false,
                subCustomer: false,
            },
            selectedSubCustomer: this.subCustomerId,
            selectedWorkType: this.workTypeId,
        }
    },
    methods: {
        reset() {
            if (!window.confirm('Are you sure you want to reset the customer and work type?')) return;

            this.selectedSubCustomer = this.subCustomerId;
            this.selectedWorkType = this.workTypeId;
        },
        submit() {
            this.$emit('update:subCustomerId', this.selectedSubCustomer);
            
            this.$emit('customerChange', this.customer.sub_customers.find((subCustomer) => {
                return subCustomer.id == this.selectedSubCustomer;
            }));

            this.$emit('update:workTypeId', this.selectedWorkType);
            
            const allWorkTypes = [
                ...this.customer.work_types, 
                ...this.customer.sub_customers.map((subCustomer) => subCustomer.work_types)
            ].flat();
            
            this.$emit('workTypeChange', allWorkTypes.find((workType) => {
                return workType.id == this.selectedWorkType;
            }));

            this.$emit('update:modelValue', false);
        }
    }
}
</script>